import React from "react";

export function VectorBackground({
    gradient = false,
    strokeColor = "#E5E2E8",
    strokeOpacity = gradient ? 1 : 0.05,
    hideTopLine = true,
    className = "",
}) {
    return (
        <div
            className={`vector-background ${
                gradient ? "vector-background--gradient" : ""
            } ${className}`.trim()}
            style={{
                "--vector-color": strokeColor,
                "--bg-offset-y": hideTopLine ? "-1px" : "0px",
                opacity: strokeOpacity,
            }}
        />
    );
}
